import { useContext } from "react";
import { Home_context } from "../../context/home_context";

export default function Identified_ingredients(){
      const { report_data_state } = useContext(Home_context);
    let dummy_data='Hyaluronic Acid, Vitamin C, Retinol, Niacinamide, Salicylic Acid'
    return (
      <div className="py-5">
        <p className="text-start font-semibold pt-2 page_headers header_color">
          Identified Ingredients{' '}
        </p>
        {/* <div className="non_table_block_padding flex gap-2 items-center">
          {
              report_data_state?.report_data['identified_ingredients']
            .split(',')
            ?.map((el) => (
              <span className="text-start page_pera_font_size titles_cards ">
                {el}
              </span>
            ))}
        </div> */}
        <p className=" non_table_block_padding text-start page_pera_font_size page_pera_color ">
          {report_data_state?.report_data['identified_ingredients']}
        </p>
      </div>
    );
}

            // <p className="text-start font-semibold pt-2 page_headers header_color" >ORIGIN</p>
            // <p className="text-start" ><span className="page_pera_font_size font-semibold">Chemical category</span> : <span className="page_pera_font_size page_pera_color" >
            //     {/* Lipidic derivative / fatty substance */}
            //     </span></p>